import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, HostBinding, Injectable, ViewEncapsulation } from '@angular/core';

export type ConfirmType = 'info' | 'warning' | 'danger' | 'success';

export class Confirm {
  public title: string;
  public question: string;

  public confirmTitle = 'Yes';
  public cancelTitle = 'No';
  public okTitle = 'OK';

  public type: ConfirmType = 'info';
  public isTypeAlert = false;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  public subject: ConfirmComponent;

  public confirm(title: string, question: string, type?: ConfirmType, confirmTitle?: string, cancelTitle?: string, okTitle?: string, isTypeAlert?: boolean): Promise<boolean> {
    const confirm = new Confirm();

    confirm.title = title;
    confirm.question = question;

    if (cancelTitle) confirm.cancelTitle = cancelTitle;

    if (confirmTitle) confirm.confirmTitle = confirmTitle;

    if (type) confirm.type = type;

    if (isTypeAlert) {
      if (okTitle) confirm.okTitle = okTitle;
      confirm.isTypeAlert = isTypeAlert;
    }

    return this.subject.setData(confirm);
  }
}

@Component({
    selector: 'confirm',
    templateUrl: 'confirm.component.html',
    styleUrls: ['confirm.component.less'],
    animations: [
        trigger('state', [
            state('inactive', style({
                opacity: '0'
            })),
            state('active', style({
                opacity: '1'
            })),
            transition('inactive <=> active', animate('400ms ease-in-out'))
        ])
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ConfirmComponent {
  public data: Confirm = null;

  @HostBinding('@state') public visible = 'inactive';
  @HostBinding('class.hidden') hidden = !this.data;

  private _resolve: any;
  private _reject: any;

  constructor(
    public confirmService: ConfirmService,
    private cdr: ChangeDetectorRef
  ) {
    confirmService.subject = this;
  }

  public reset() {
    this.data = null;
    this.hidden = true;
    this._resolve = null;
    this._reject = null;
  }

  public setData(confirm: Confirm): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
      this.data = confirm;
      this.hidden = false;
      setTimeout(() => {
        this.visible = 'active';
        this.cdr.markForCheck();
      });
    });
  }

  public confirm() {
    this.visible = 'inactive';
    this._resolve(true);
    this.reset();
  }

  public cancel($event: any) {
    this.visible = 'inactive';

    $event.stopPropagation();
    this._resolve(false);
    this.reset();
  }
}
